import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./style.css";
import axios from "axios";
import { FeedPostMenu } from "../shared";
import EditPostPopup from "../../editPostPopup";

export default function EbookFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState("all");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [selectedBook, setSelectedBook] = useState(null);
  const [editingPost, setEditingPost] = useState(null);

  const handleEditPost = (post) => {
    setSelectedBook(null);
    setEditingPost(post);
  };
  const handlePostUpdated = (updatedPost) => {
    setPosts(prev => prev.map(p => p._id === updatedPost._id ? updatedPost : p));
    setEditingPost(null);
  };
  const handlePostDeleted = (postId) => {
    setPosts(prev => prev.filter(p => p._id !== postId));
    setSelectedBook(null);
  };

  const categories = [
    { id: "all", name: "Todos" },
    { id: "fiction", name: "Ficção" },
    { id: "non-fiction", name: "Não-Ficção" },
    { id: "biography", name: "Biografias" },
    { id: "business", name: "Negócios" },
    { id: "self-help", name: "Autoajuda" },
    { id: "tech", name: "Tecnologia" },
    { id: "romance", name: "Romance" },
    { id: "thriller", name: "Thriller" },
  ];

  const fetchPosts = async (pageNum = 1) => {
    try {
      let url = `${process.env.REACT_APP_BACKEND_URL}/feed/ebook?page=${pageNum}&limit=16`;
      if (category !== "all") url += `&category=${category}`;

      const { data } = await axios.get(url, { headers: { Authorization: `Bearer ${user.token}` } });
      if (pageNum === 1) setPosts(data.posts || []);
      else setPosts((prev) => [...prev, ...(data.posts || [])]);
      setHasMore((data.pagination?.page || 1) < (data.pagination?.pages || 1));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching ebooks:", error);
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { setPage(1); fetchPosts(1); }, [category]);

  const formatPrice = (price) => {
    if (!price || price === 0) return "Grátis";
    return `R$ ${typeof price === "number" ? price.toFixed(2) : price}`;
  };

  if (loading && posts.length === 0) {
    return <div className="ebook_feed_loading"><div className="ebook_loader"></div><span>Carregando e-books...</span></div>;
  }

  return (
    <div className="ebook_feed">
      {categories.length > 0 && (
        <div className="simple_filter_bar">
          <div className="filter_buttons">
            {categories.map((filter) => (
              <button
                key={filter.id}
                className={`filter_btn ${category === filter.id ? "active" : ""}`}
                onClick={() => setCategory(filter.id)}
              >
                {filter.name}
              </button>
            ))}
          </div>
        </div>
      )}

      {posts.length === 0 ? (
        <div className="ebook_feed_empty">
          <svg viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
            <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"/>
          </svg>
          <h3>Nenhum e-book encontrado</h3>
          <p>Seja o primeiro a compartilhar um e-book!</p>
        </div>
      ) : (
        <div className="ebook_grid">
          {posts.map((post) => (
            <div key={post._id} className="ebook_card" onClick={() => setSelectedBook(post)}>
              <div className="ebook_cover">
                <img src={post.ebookData?.coverImage || post.images?.[0]?.url || post.images?.[0] || "/images/default-ebook.png"} alt="" />
                {post.ebookData?.isFree && <span className="ebook_free_badge">Grátis</span>}
              </div>
              <div className="ebook_card_content">
                <h3>{post.ebookData?.title || post.text}</h3>
                <p className="ebook_author_name">{post.ebookData?.author || "Autor desconhecido"}</p>
                <Link to={`/profile/${post.user.username}`} className="ebook_uploader" onClick={(e) => e.stopPropagation()}>
                  <img src={post.user.picture} alt="" />
                  <span>{post.user.first_name}</span>
                </Link>
                <div className="ebook_meta">
                  {post.ebookData?.pages && <span>{post.ebookData.pages} páginas</span>}
                  {post.ebookData?.rating > 0 && <span>⭐ {post.ebookData.rating.toFixed(1)}</span>}
                </div>
                <div className="ebook_price">{formatPrice(post.ebookData?.price)}</div>
                <div onClick={(e) => e.stopPropagation()}>
                  <FeedPostMenu
                    post={post}
                    onEdit={handleEditPost}
                    onPostDeleted={handlePostDeleted}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {hasMore && (
        <div className="ebook_load_more">
          <button onClick={() => { setPage(p => p + 1); fetchPosts(page + 1); }} disabled={loading}>
            {loading ? "Carregando..." : "Ver mais e-books"}
          </button>
        </div>
      )}

      {editingPost && (
        <EditPostPopup
          post={editingPost}
          user={user}
          setVisible={(visible) => !visible && setEditingPost(null)}
          onPostUpdated={handlePostUpdated}
        />
      )}

      {selectedBook && (
        <div className="ebook_modal_overlay" onClick={() => setSelectedBook(null)}>
          <div className="ebook_modal" onClick={(e) => e.stopPropagation()}>
            <button className="ebook_modal_close" onClick={() => setSelectedBook(null)}>✕</button>
            <div className="ebook_modal_content">
              <div className="ebook_modal_cover">
                <img src={selectedBook.ebookData?.coverImage || selectedBook.images?.[0]} alt="" />
              </div>
              <div className="ebook_modal_info">
                <h2>{selectedBook.ebookData?.title}</h2>
                <p className="ebook_modal_author">por {selectedBook.ebookData?.author || "Autor desconhecido"}</p>
                <p className="ebook_modal_desc">{selectedBook.ebookData?.description || selectedBook.text}</p>
                <div className="ebook_modal_details">
                  {selectedBook.ebookData?.pages && <div><strong>Páginas:</strong> {selectedBook.ebookData.pages}</div>}
                  {selectedBook.ebookData?.language && <div><strong>Idioma:</strong> {selectedBook.ebookData.language}</div>}
                  {selectedBook.ebookData?.isbn && <div><strong>ISBN:</strong> {selectedBook.ebookData.isbn}</div>}
                </div>
                <div className="ebook_modal_footer">
                  <span className="ebook_modal_price">{formatPrice(selectedBook.ebookData?.price)}</span>
                  <button className="ebook_download_btn">Baixar E-Book</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
